module.exports = __webpack_public_path__ + "img/2f_bj.70bed8f.png";